<template src="./index.html" />

<script>
import {
  BButton,
  BCol,
  BRow,
  BCard,
  BPagination,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BFormCheckbox,
  BTabs,
  BTab, BOverlay, BTable,
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import '@core/scss/vue/libs/vue-good-table.scss'
import FormSchedule from '@/views/scheduler/FormSchedule.vue'
import SchedulerCalendar from '@/views/scheduler/SchedulerCalendar.vue'
import { getUser } from '@/auth/utils'
import vSelect from 'vue-select'
import { hasPermissionForResource, isSystemAdmin } from '@/utils'
import {
  PermissionCode, ResourceCode,
} from '@/const/code'
import ImportScheduler from '@/views/scheduler/importScheduler/ImportScheduler.vue'
import * as XLSX from 'xlsx'
import Ripple from 'vue-ripple-directive'
import creditClassApi from '@/views/credit-class/api'
import { showErrorToast, showSuccessToast, showWarningToast } from '@/utils/notification'
import api from './api'

export default {
  name: 'Scheduler',
  directives: {
    Ripple,
  },
  components: {
    BOverlay,
    BButton,
    BCol,
    BRow,
    BCard,
    BPagination,
    BFormGroup,
    vSelect,
    BFormInput,
    BFormSelect,
    VueGoodTable,
    FormSchedule,
    BFormCheckbox,
    BTabs,
    BTab,
    BTable,
    ImportScheduler,
    SchedulerCalendar,
  },
  data() {
    return {
      user: getUser(),
      table: {
        fields: [
          {
            field: 'subjectName',
            label: 'Học phần',
            sortable: false,
            type: 'string',
            filterOptions: {
              enabled: true,
              trigger: 'enter',
            },
          },
          {
            field: 'creditClassCode',
            label: 'Lớp độc lập',
            sortable: false,
            type: 'string',
            filterOptions: {
              enabled: true,
              trigger: 'enter',
            },
          },
          {
            field: 'yearWeekCode',
            label: 'Tuần học',
            sortable: false,
            type: 'string',
            filterOptions: {
              enabled: true,
              trigger: 'enter',
            },
          },
          {
            field: 'roomName',
            label: 'Phòng học',
            sortable: false,
            type: 'string',
            filterOptions: {
              enabled: true,
              trigger: 'enter',
            },
          },
          {
            field: 'schedule', label: 'Thời gian', sortable: false, type: 'string',
          },
          {
            field: 'teacherName',
            label: 'Giảng viên',
            sortable: false,
            type: 'string',
            filterOptions: {
              enabled: true,
              trigger: 'enter',
            },
          },
          {
            field: 'action', tdClass: 'text-center', thClass: 'text-center', label: 'Thao tác', sortable: false,
          },
        ],
        items: [],
      },
      itemsDisplay: [],
      totalRecords: 0,
      isLoading: false,
      serverParams: {
        columnFilters: {},
        sort: [{ field: '', type: '' }],
        page: 1,
        perPage: 10,
      },
      dataSendForm: { isCreated: 0 },
      filter: {
        currentPage: 1,
        itemsPerPage: 10,
        yearId: null,
        semesterId: null,
        majorId: null,
        status: 1,
        maxStatus: 3,
        sort: '',
        subjectName: '',
        creditClassCode: '',
        academicYear: '',
        weekNumber: '',
        roomId: '',
        studentId: '',
      },
      activeTab: 0,
      teacherOptions: [],
      titleNameDelete: '',
      checkRemoveAll: '0',
      itemDelete: {},
      checkAllWeek: '',
      isHandleSaveSuccess: false,

      schedulers: [],
      total: 0,
      weeklyScheduleData: {},
      isLoadingWeekly: false,
      weeklyScheduleTimeout: null,
      mainDataTimeout: null,
      weeklyPagination: {
        currentPage: 1,
        itemsPerPage: 10,
        totalRecords: 0,
      },
      years: [],
      courses: [],
      semesters: [],
      majors: [],
      columnsExport: [
        {
          label: 'Học phần',
          field: 'stringSubjectExport',
        },
        {
          label: 'Lớp độc lập',
          field: 'creditClassCode',
        },
        {
          label: 'Phòng học',
          field: 'roomName',
        },
        {
          label: 'Tuần',
          field: 'yearWeekCode',
        },
        {
          label: 'Thứ tiết',
          field: 'stringDayTurnExport',
        },
        {
          label: 'Giảng viên',
          field: 'teacherName',
        },
      ],
    }
  },
  computed: {
    creatable() {
      return isSystemAdmin() || hasPermissionForResource(PermissionCode.CREATE, ResourceCode.SCHEDULE)
    },
    updatable() {
      return isSystemAdmin() || hasPermissionForResource(PermissionCode.UPDATE, ResourceCode.SCHEDULE)
    },
    deletable() {
      return isSystemAdmin() || hasPermissionForResource(PermissionCode.DELETE, ResourceCode.SCHEDULE)
    },
  },
  watch: {
    'filter.yearId': function () {
      this.debouncedGetWeeklyScheduleData()
      this.debouncedGetMainDataFromStore()
    },
    'filter.semesterId': function () {
      this.debouncedGetWeeklyScheduleData()
      this.debouncedGetMainDataFromStore()
    },
    'filter.majorId': function () {
      this.debouncedGetWeeklyScheduleData()
      this.debouncedGetMainDataFromStore()
    },
  },
  async created() {
    this.isLoading = true
    try {
      const [courses, semesters, majors] = await Promise.all([
        creditClassApi.getCourses({
          currentPage: 1,
          itemsPerPage: 99999,
        }),
        creditClassApi.getSemesters(),
        creditClassApi.getMajorsByOrganizationId(),
      ])
      this.courses = courses
      this.semesters = semesters
      this.majors = majors
      await this.getWeeklyScheduleData()
    } catch (e) {
      showErrorToast(this, e)
    } finally {
      this.isLoading = false
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.hideTabTitles()
    })
  },
  methods: {
    hideTabTitles() {
      const myTabs = document.querySelector('.my-tabs')
      if (myTabs) {
        const navTabs = myTabs.querySelectorAll('.nav-tabs, .nav, ul.nav-tabs, ul.nav')
        navTabs.forEach(nav => {
          if (nav) {
            nav.style.display = 'none'
          }
        })

        const navItems = myTabs.querySelectorAll('.nav-item, .nav-link')
        navItems.forEach(item => {
          if (item) {
            item.style.display = 'none'
          }
        })
      }
    },
    updateParams(newProps) {
      this.filter = { ...this.filter, ...newProps }
    },
    async onPageChange(param) {
      this.updateParams({ currentPage: param.currentPage })
      await this.getMainDataFromStore()
    },
    async onPerPageChange(param) {
      this.updateParams({
        currentPage: 1,
        itemsPerPage: param.currentPerPage,
      })
      await this.getMainDataFromStore()
    },
    async onSortChange(param) {
      if (param.length > 0) {
        const { field, type } = param[0]
        const selectedColumn = this.table.fields.findIndex(e => e.field === field)
        this.updateParams({ sort: `${selectedColumn}_${type}` })
      }
      await this.getMainDataFromStore()
    },
    async onColumnFilter(param) {
      const { columnFilters } = param
      if (Object.hasOwn(columnFilters, 'subjectName')) this.updateParams({ subjectName: columnFilters.subjectName })
      if (Object.hasOwn(columnFilters, 'creditClassCode')) this.updateParams({ creditClassCode: columnFilters.creditClassCode })
      if (Object.hasOwn(columnFilters, 'yearWeekCode')) this.updateParams({ yearWeekCode: columnFilters.yearWeekCode })
      if (Object.hasOwn(columnFilters, 'roomName')) this.updateParams({ roomName: columnFilters.roomName })
      if (Object.hasOwn(columnFilters, 'teacherName')) this.updateParams({ teacherName: columnFilters.teacherName })
      await this.getMainDataFromStore()
    },
    onImportScheduler() {
      this.$bvModal.show('modal-import-scheduler')
    },
    openModal() {
      this.dataSendForm = {}
      this.$bvModal.show('form-schedule')
    },
    deleteWeekly(item) {
      item.checkRemoveAll = 1
      this.$swal({
        title: 'Bạn chắc chắn muốn xóa TKB của lớp học phần này',
        text: 'Bạn sẽ không thể khôi phục lại dữ liệu này!',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: '<i class="fa-solid fa-check"></i> Đồng ý',
        cancelButtonText: '<i class="fa-solid fa-times"></i> Hủy',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(async result => {
        if (result.isConfirmed) {
          try {
            const params = {
              creditClassId: item.creditClassId,
              checkRemoveAll: 1,
            }
            const response = await api.deleteScheduleByCreditClass(params)
            if (response) {
              const { isSuccessful, message } = response
              if (isSuccessful) {
                showSuccessToast(this, 'Đã xóa thành công!')
                this.$emit('saveDataSuccess')
              } else {
                showWarningToast(this, `Có lỗi xảy ra ${message}`)
              }
            }
          } catch (e) {
            showErrorToast(this, e)
          } finally {
            await this.getWeeklyScheduleData()
          }
        }
      })
    },
    loadItems() {
      this.btnSearchClick()
    },
    async deleteItem(item) {
      this.itemDelete = item
      this.titleNameDelete = `Xóa lịch học tuần ${this.weeks.find(week => week.id === this.filter.yearWeekId)?.code || ''} của lớp độc lập ${item.creditClassCode}`
      this.$bvModal.show('modal-schedule-delete')
    },
    async handleOk(bvModalEvent) {
      bvModalEvent.preventDefault()
      this.isLoading = true
      try {
        this.itemDelete.checkRemoveAll = this.checkRemoveAll
        const result = await api.deleteScheduleByCreditClass(this.itemDelete)
        if (result) {
          await this.getMainDataFromStore()
          showSuccessToast(this, 'Đã xóa thành công!')
          this.$bvModal.hide('modal-schedule-delete')
        } else {
          showErrorToast(this, 'Có lỗi xảy ra!')
        }
      } catch (e) {
        showErrorToast(this, e)
      } finally {
        this.isLoading = false
      }
    },
    async edit(data) {
      this.dataSendForm = data
      this.$bvModal.show('form-schedule')
    },
    async editForm(data) {
      this.dataSendForm = data
      this.$bvModal.show('form-schedule')
    },
    async onYearChange(event) {
      this.isLoading = true
      try {
        this.filter.yearId = event
        this.resetWeeklyPagination()
        this.debouncedGetWeeklyScheduleData()
        this.debouncedGetMainDataFromStore()
      } catch (e) {
        showErrorToast(this, e)
      } finally {
        this.isLoading = false
      }
    },
    async onSemesterChange(event) {
      this.isLoading = true
      try {
        this.filter.semesterId = event
        this.resetWeeklyPagination()
        this.debouncedGetWeeklyScheduleData()
        this.debouncedGetMainDataFromStore()
      } catch (e) {
        showErrorToast(this, e)
      } finally {
        this.isLoading = false
      }
    },
    async onMajorChange(event) {
      this.isLoading = true
      try {
        this.filter.majorId = event
        this.resetWeeklyPagination()
        this.debouncedGetWeeklyScheduleData()
        this.debouncedGetMainDataFromStore()
      } catch (e) {
        showErrorToast(this, e)
      } finally {
        this.isLoading = false
      }
    },
    async saveDataForm(data) {
      this.isLoading = true
      const objData = {
        creditClassId: data.creditClassId,
        roomId: data.roomId,
        teacherId: data.teacherId,
        listDayCheck: data.listDayCheck,
        beginDate: data.beginDate,
        weeks: data.weeks,
        isUpdate: data.isUpdate,
      }
      try {
        const res = await api.createSchedule(objData)
        if (res.isSuccessful) {
          if (data.type === 0) {
            this.$bvModal.hide('form-schedule')
          }
          this.isHandleSaveSuccess = true
          showSuccessToast(this, res.message || 'Thêm lịch học thành công!')
          if (data.isUpdate) {
            await this.getMainDataFromStore()
          }
          await this.getWeeklyScheduleData()
        } else {
          showErrorToast(this, res.message || 'Có lỗi xảy ra!')
        }
      } catch (e) {
        showErrorToast(this, e)
      } finally {
        this.isLoading = false
      }
    },

    async onScheduleSavedSuccessfully() {
      await this.getWeeklyScheduleData()
    },
    async getMainDataFromStore() {
      this.isLoading = true
      try {
        const response = await api.selectSchedulers(this.filter)
        this.schedulers = response.records || []
        this.total = response.total || 0
        if (this.schedulers.length > 0) {
          this.schedulers.forEach(item => {
            // eslint-disable-next-line no-param-reassign
            item.dayTurns = []
            let stringDayTurnExport = ''
            const groupDays = item.groupDays ? item.groupDays.split(',') : []
            const groupDayIds = item.groupDayIds ? item.groupDayIds.split(',') : []
            const groupTurns = item.groupTurns ? item.groupTurns.split('|') : []
            const groupTurnIds = item.groupTurnIds ? item.groupTurnIds.split('|') : []
            let htmlDayTurn = ''
            const groupDayTurn = []
            if (groupDays.length > 0) {
              // eslint-disable-next-line no-plusplus
              for (let i = 0; i < groupDays.length; i++) {
                const dayTurn = { dayId: 0, turnIds: [] }
                groupTurns[i] = groupTurns[i].substr(0, 1).replace(',', '') + groupTurns[i].substring(1)
                htmlDayTurn += `<li class="m-0 p-0 list-group-item">&#128197;${groupDays[i]}: &#9200;[${groupTurns[i]}]</li>`
                stringDayTurnExport += `${groupDays[i]}(${groupTurns[i]})${i < groupDays.length - 1 ? ',' : ''}`
                dayTurn.dayId = groupDayIds[i]
                let turnIds = groupTurnIds[i].split(',')
                turnIds = turnIds.filter(t => t !== '')
                dayTurn.turnIds = turnIds
                groupDayTurn.push(dayTurn)
              }
            }
            // eslint-disable-next-line no-param-reassign
            item.schedule = `<ul class="m-0 p-0 list list-group-flush">${htmlDayTurn}</ul>`
            // eslint-disable-next-line no-param-reassign
            item.dayTurns = groupDayTurn
            item.stringDayTurnExport = stringDayTurnExport
            item.stringSubjectExport = `${item.subjectName}(${item.subjectCode})`
          })
        }
        this.table.items = this.schedulers
      } catch (e) {
        showErrorToast(this, e)
      } finally {
        this.isLoading = false
      }
    },
    async onTabChange(tabIndex) {
      this.activeTab = tabIndex
      if (tabIndex === 0) {
        this.weeklyPagination.currentPage = 1
        await this.getWeeklyScheduleData()
      } else if (tabIndex === 2) {
        this.$nextTick(() => {
          this.$refs.schedulerCalendar?.refreshCalendar()
        })
      }
    },
    exportExcelTKB() {
      if (this.schedulers.length === 0) {
        showWarningToast(this, 'Không có dữ liệu để xuất!')
        return
      }
      const data = []
      const header = {}
      this.columnsExport.forEach(column => {
        header[column.field] = column.label
      })
      const headerKeys = Object.keys(header)
      const dataSourceKeys = Object.keys(this.schedulers[0])
      const duplicates = dataSourceKeys.filter(val => headerKeys.includes(val))
      duplicates.sort((a, b) => headerKeys.indexOf(a) - headerKeys.indexOf(b))
      this.schedulers.forEach(dataSource => {
        const elm = {}
        duplicates.forEach(key => {
          elm[header[key]] = dataSource[key]
        })
        data.push(elm)
      })
      const ws = XLSX.utils.json_to_sheet(data)
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, ws, 'ThoiKhoaBieu')
      XLSX.writeFile(wb, 'ThoiKhoaBieu.xlsx')
    },

    debouncedGetWeeklyScheduleData() {
      clearTimeout(this.weeklyScheduleTimeout)
      this.weeklyScheduleTimeout = setTimeout(() => {
        this.getWeeklyScheduleData()
      }, 500)
    },

    debouncedGetMainDataFromStore() {
      clearTimeout(this.mainDataTimeout)
      this.mainDataTimeout = setTimeout(() => {
        this.getMainDataFromStore()
      }, 500)
    },

    async getWeeklyScheduleData() {
      this.isLoadingWeekly = true
      try {
        const params = {
          currentPage: this.weeklyPagination.currentPage,
          itemsPerPage: this.weeklyPagination.itemsPerPage,
          trainingSystemId: this.filter.trainingSystemId || null,
          courseId: this.filter.courseId || null,
          semesterId: this.filter.semesterId || null,
          majorId: this.filter.majorId || null,
          subjectName: this.filter.subjectName || null,
          creditClassCode: this.filter.creditClassCode || null,
        }

        const result = await api.getSchedulesWeekly(params)
        if (result) {
          this.weeklyScheduleData = result.records || []
          this.weeklyPagination.totalRecords = result.total || 0
        } else {
          this.weeklyScheduleData = []
          this.weeklyPagination.totalRecords = 0
        }
      } catch (e) {
        showErrorToast(this, e)
        this.weeklyScheduleData = []
        this.weeklyPagination.totalRecords = 0
      } finally {
        this.isLoadingWeekly = false
      }
    },

    getTeacherInfo(item) {
      const schedule = item.weeklySchedule
      if (!schedule) return '-'

      const teachers = []
      Object.values(schedule).forEach(daySchedule => {
        if (daySchedule && daySchedule.teacherName) {
          const teacherNames = daySchedule.teacherName.split(',').map(name => name.trim()).filter(name => name !== '')
          teacherNames.forEach(teacherName => {
            const normalizedName = teacherName.trim()
            if (normalizedName && !teachers.includes(normalizedName)) {
              teachers.push(normalizedName)
            }
          })
        }
      })
      const uniqueTeachers = [...new Set(teachers)]
      return uniqueTeachers.length > 0 ? uniqueTeachers.join(', ') : '-'
    },

    getRoomInfo(item) {
      const schedule = item.weeklySchedule
      if (!schedule) return '-'

      const rooms = []
      Object.values(schedule).forEach(daySchedule => {
        if (daySchedule && daySchedule.roomName) {
          // Tách các phòng bằng dấu phẩy và thêm vào mảng
          const dayRooms = daySchedule.roomName.split(',').map(r => r.trim()).filter(r => r !== '')
          dayRooms.forEach(room => {
            if (!rooms.includes(room)) {
              rooms.push(room)
            }
          })
        }
      })
      return rooms.length > 0 ? rooms.join(', ') : '-'
    },

    getPeriodsInfo(item) {
      const schedule = item.weeklySchedule
      if (!schedule) return '-'

      const periods = []
      Object.values(schedule).forEach(daySchedule => {
        if (daySchedule && daySchedule.periods) {
          // Tách các tiết bằng dấu phẩy và thêm vào mảng
          const dayPeriods = daySchedule.periods.split(',').map(p => p.trim()).filter(p => p !== '')
          dayPeriods.forEach(period => {
            if (!periods.includes(period)) {
              periods.push(period)
            }
          })
        }
      })
      return periods.length > 0 ? periods.join(', ') : '-'
    },

    getWeeksInfo(item) {
      const schedule = item.weeklySchedule
      if (!schedule) return '-'

      const weeks = []
      Object.values(schedule).forEach(daySchedule => {
        if (daySchedule && daySchedule.weeks) {
          // Tách các tuần bằng dấu phẩy và thêm vào mảng
          const dayWeeks = daySchedule.weeks.split(',').map(w => w.trim()).filter(w => w !== '')
          dayWeeks.forEach(week => {
            if (!weeks.includes(week)) {
              weeks.push(week)
            }
          })
        }
      })

      // Sắp xếp tuần theo thứ tự từ bé đến lớn
      weeks.sort((a, b) => {
        // Chuyển đổi thành số để so sánh
        const numA = parseInt(a, 10)
        const numB = parseInt(b, 10)
        return numA - numB
      })

      return weeks.length > 0 ? weeks.join(', ') : '-'
    },

    async onWeeklyPageChange(page) {
      this.weeklyPagination.currentPage = page
      await this.getWeeklyScheduleData()
    },

    async onWeeklyPerPageChange(perPage) {
      this.weeklyPagination.currentPage = 1
      this.weeklyPagination.itemsPerPage = perPage
      await this.getWeeklyScheduleData()
    },

    resetWeeklyPagination() {
      this.weeklyPagination.currentPage = 1
    },

    // KHÔNG cho phép edit lịch theo lớp học phần ở trường nghề
    weeklyUpdatable(schedule) {
      return false  // Luôn trả về false để ẩn nút edit
    },
  },
}
</script>

<style lang="scss" scoped>
/* Tab Switch Styles - giống ImportCertificate.vue */
.tab-switch {
  display: inline-flex;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  overflow: hidden;
  background: #f8f9fa;
}

.tab-btn {
  border: none;
  background: transparent;
  padding: 8px 16px;
  font-size: 0.9rem;
  color: #495057;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  white-space: nowrap;
}

.tab-btn + .tab-btn {
  border-left: 1px solid #dee2e6;
}

.tab-btn.active {
  background: #1e90ff;
  color: #fff;
}

.tab-btn:hover:not(.active) {
  background: #e9ecef;
}

.tab-btn:focus {
  outline: none;
}

.mr-50 {
  margin-right: 0.5rem;
}

.my-tabs .nav-tabs,
.my-tabs .nav,
.my-tabs ul.nav-tabs,
.my-tabs ul.nav {
  display: none !important;
}

.my-tabs .nav-item,
.my-tabs .nav-link {
  display: none !important;
}

.my-tabs .tab-content {
  border: none !important;
  padding: 0 !important;
}

.my-tabs .nav-tabs:not(.show),
.my-tabs .nav:not(.show) {
  display: none !important;
}

.my-tabs .nav-tabs li,
.my-tabs .nav li {
  display: none !important;
}

div.my-tabs .nav-tabs,
div.my-tabs .nav,
div.my-tabs ul.nav-tabs,
div.my-tabs ul.nav,
div.my-tabs .nav-item,
div.my-tabs .nav-link {
  display: none !important;
}

.my-tabs .nav-tabs *,
.my-tabs .nav * {
  display: none !important;
}

.tab-1 .tab-content {
  display: none !important;
}

.weekly-schedule-container {
  background: #fff;
  border-radius: 8px;
}

.weekly-header {
  background: #f8f9fa;
  padding: 15px;
  border-radius: 6px;
  border: 1px solid #dee2e6;
}

.weekly-table {
  font-size: 14px;
}

.weekly-table th {
  background-color: #e9ecef;
  font-weight: bold;
  text-align: center;
  vertical-align: middle;
  border: 1px solid #dee2e6;
  padding: 12px 8px;
}

.weekly-table td {
  border: 1px solid #dee2e6;
  padding: 8px;
  vertical-align: top;
}

.subject-info {
  min-width: 200px;
}

.subject-info strong {
  color: #495057;
  font-size: 14px;
}

.class-info {
  min-width: 150px;
}

.class-info strong {
  color: #495057;
  font-size: 14px;
}

.schedule-info {
  min-width: 180px;
  font-size: 12px;
  line-height: 1.4;
}

.schedule-info div {
  margin-bottom: 4px;
}

.weekly-table {
  font-size: 12px;
  border-collapse: collapse;
}

.weekly-table th {
  background-color: #e9ecef;
  font-weight: bold;
  text-align: center;
  vertical-align: middle;
  border: 1px solid #dee2e6;
  padding: 8px 6px;
  font-size: 13px;
}

.weekly-table td {
  border: 1px solid #dee2e6;
  padding: 4px 6px;
  vertical-align: middle;
  line-height: 1.2;
}

/* Sticky header for weekly table inside the Weekly tab */
.weekly-schedule-table {
  /* Make the table area scrollable so the header can stick */
  max-height: 60vh;
  overflow: auto;
}

/* Ensure proper stacking context and spacing for sticky header */
.weekly-table {
  border-collapse: separate;
  border-spacing: 0;
  --weekly-header-height: 44px; /* height of the first header row */
}

/* First header row (titles) sticks to the top */
.weekly-table thead tr:first-child th {
  position: sticky;
  top: 0;
  z-index: 3;
  background: #e9ecef; /* same as existing header bg */
}

/* Second header row (filters) sticks below the first row */
.weekly-table thead tr.filter-row th {
  position: sticky;
  top: var(--weekly-header-height);
  z-index: 2;
  background: #ffffff; /* make filters readable while sticking */
}

/* Optional: add a subtle divider shadow under sticky rows */
.weekly-table thead tr:first-child th::after,
.weekly-table thead tr.filter-row th::after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 1px;
  background: #dee2e6;
}

.subject-header {
  background-color: #f3e5f5 !important;
  color: #7b1fa2 !important;
}

.class-header {
  background-color: #e8f5e8 !important;
  color: #388e3c !important;
}

.info-header {
  background-color: #fff3e0 !important;
  color: #f57c00 !important;
}

.day-header {
  background-color: #e3f2fd !important;
  color: #1976d2 !important;
}

.filter-row th {
  background-color: #f8f9fa !important;
  border-top: 2px solid #dee2e6 !important;
  padding: 6px 4px !important;
}

.filter-row th input {
  font-size: 11px;
  border: 1px solid #ced4da;
  border-radius: 4px;
}

.filter-row th input:focus {
  border-color: #80bdff;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.subject-cell {
  background-color: #fafafa;
  vertical-align: middle !important;
}

.class-cell {
  background-color: #fafafa;
  vertical-align: middle !important;
}

.info-cell {
  background-color: #fff8e1;
  font-size: 11px;
  line-height: 1.1;
  padding: 3px 4px;
  min-width: 100px;
}

.day-cell {
  background-color: #f8f9fa;
  font-size: 11px;
  line-height: 1.1;
  text-align: center;
  padding: 3px 4px;
  min-width: 30px;
}

.subject-info {
  min-width: 100px;
  line-height: 1.2;
}

.subject-info strong {
  color: #495057;
  font-size: 12px;
}

.subject-info small {
  font-size: 10px;
}

.class-info {
  min-width: 100px;
  line-height: 1.2;
}

.class-info strong {
  color: #495057;
  font-size: 12px;
}

.class-info small {
  font-size: 10px;
}
.schedule-detail div {
  margin-bottom: 2px;
}

.schedule-detail strong {
  color: #495057;
}

@media (max-width: 768px) {
  .weekly-table {
    font-size: 12px;
  }

  .weekly-table th,
  .weekly-table td {
    padding: 6px 4px;
  }

  .subject-info,
  .class-info,
  .schedule-info {
    min-width: auto;
  }

  .day-schedule {
    min-width: 50px;
    min-height: 60px;
  }

  .schedule-detail {
    padding: 4px;
    font-size: 10px;
  }
}

.weekly-table th:hover,
.weekly-table td:hover {
  background-color: #f8f9fa;
}

.weekly-table th:nth-child(5),
.weekly-table th:nth-child(6),
.weekly-table th:nth-child(7),
.weekly-table th:nth-child(8),
.weekly-table th:nth-child(9),
.weekly-table th:nth-child(10),
.weekly-table th:nth-child(11) {
  background-color: #e3f2fd;
  color: #1976d2;
  font-weight: bold;
}

.weekly-table th:nth-child(4) {
  background-color: #fff3e0;
  color: #f57c00;
}

.weekly-table th:nth-child(2) {
  background-color: #f3e5f5;
  color: #7b1fa2;
}

.weekly-table th:nth-child(3) {
  background-color: #e8f5e8;
  color: #388e3c;
}

.stt-header {
  background-color: #f8f9fa !important;
  color: #6c757d !important;
  font-weight: bold;
  min-width: 30px;
}

.stt-cell {
  background-color: #f8f9fa;
  vertical-align: middle !important;
  text-align: center;
  min-width: 30px;
}

.stt-info {
  font-size: 14px;
  font-weight: bold;
  color: #495057;
}
</style>
